import { createContext } from 'react'

import { translationHandler } from '../utils/translationHandler'
import { I18nType } from './types'

export const i18nTranslationHandler = translationHandler()

export const i18n: I18nType = {
  blockHTML: i18nTranslationHandler.blockHTML,
  handleLocale: () => {
    throw new Error('You need to implement "handleLocale"')
  },
  inlineHTML: i18nTranslationHandler.inlineHTML,
  isTranslationsLoading: true,
  locale: i18nTranslationHandler.locale,
  replace: i18nTranslationHandler.replace,
  replaceNodes: i18nTranslationHandler.replaceNodes,
  t: i18nTranslationHandler.t,
  table: i18nTranslationHandler.table,
}

export const I18nContext = createContext(i18n)
